export const USER_HISTORY_ACTIVITY = '/api/v1/user/activity';
export const USER_ACTIVE_DEVICE = '/api/v1/user/devices';
export const USER_REVOKE_DEVICE = '/api/v1/user/logout/device';
export const RESET_PASSWORD = '/api/v1/user/password/reset';
export const ACTIVE_GA = '/api/v1/user/mfa/active/ga';
export const ACTIVE_GA_VERIFY = '/api/v1/user/mfa/verify/ga';
export const ACTIVE_EMAIL = '/api/v1/user/mfa/active/email';
export const ACTIVE_EMAIL_VERIFY = '/api/v1/user/mfa/verify/email';
export const ACTIVE_SMS = '/api/v1/user/mfa/active/sms';
export const ACTIVE_SMS_VERIFY = '/api/v1/user/mfa/verify/sms';
export const ACTIVE_MFA_RESEND = '/api/v1/user/active/mfa/resend'; // resend mfa code for email and mobile
